import React from "react";
import locale from "locale";
import { useLocation } from "react-router-dom";
import { Table, DropdownButton, MenuItem, Label } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import { RECIPIENTS_SOURCES, STATUSES } from "../constants";
import { CUSTOM_TEMPLATE_TYPE } from "../../LettersConstructor/models";

const RemindersTable = ({
    reminders,
    onEdit,
    onSubmit,
    onPreview,
    onDelete,
}) => {
    if (!reminders) {
        return null;
    }

    const location = useLocation();

    function isCustomType(reminder) {
        return reminder.type === CUSTOM_TEMPLATE_TYPE;
    }

    function handleConfirmRemove(reminder) {
        const allow = confirm(`${locale("reminders.removeReminder")}?`);

        allow && onDelete(reminder);
    }

    function getMailingMethod(reminder) {
        if (reminder.sendPeriodic) {
            return "Периодическая";
        }

        if (reminder.sendPeriodic === 0) {
            return "В заданное время";
        }

        return "Вручную";
    }

    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>{locale("reminders.letterType")}</th>
                        <th>{locale("reminders.recepientSource")}</th>
                        <th>{locale("reminders.templateTitle")}</th>
                        <th>{locale("reminders.mailSubject")} (Ru)</th>
                        <th>{locale("reminders.mailingMethod")} (Ru)</th>
                        <th>{locale("reminders.mailingTime")}</th>
                        <th>{locale("reminders.status")}</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {reminders.map((reminder, index) => (
                        <tr key={index}>
                            <td>{reminder.id}</td>
                            <td>
                                {locale(`reminders.${reminder.type}Reminder`)}
                            </td>
                            <td>
                                {RECIPIENTS_SOURCES[reminder.recipientsSource]}
                            </td>
                            <td>{reminder.emailMessageTemplate.name}</td>
                            <td>{reminder.subjectRu || "Без темы"}</td>
                            <td>{getMailingMethod(reminder)}</td>
                            <td>
                                {reminder.sendAt
                                    ? reminder.sendAt
                                    : locale("reminders.no")}
                            </td>
                            <td>{STATUSES[reminder.status]}</td>
                            <td style={{ textAlign: "right" }}>
                                <DropdownButton
                                    id="createReminderButton"
                                    title={locale("reminders.actions")}
                                    bsSize="sm"
                                    pullRight
                                >
                                    {
                                        reminder.status !== 'done' &&
                                        <MenuItem onClick={() => onEdit(reminder)}>
                                            {locale("reminders.edit")}
                                        </MenuItem>
                                    }
                                    {isCustomType(reminder) && (
                                        <MenuItem
                                            onClick={() =>
                                                onSubmit(reminder.id)
                                            }
                                        >
                                            {locale("reminders.sendNow")}
                                        </MenuItem>
                                    )}
                                    {/* <MenuItem
                                        onClick={() => onPreview(reminder)}
                                    >
                                        {locale("reminders.watch")}
                                    </MenuItem> */}
                                    <LinkContainer
                                        to={`${location.pathname}/statistics/details/${reminder.id}`}
                                    >
                                        <MenuItem>
                                            {locale('reminders.statistics')}
                                            <Label 
                                                bsStyle="warning"
                                                style={{marginLeft: '4px'}}
                                            >
                                                BETA
                                            </Label>                                        
                                        </MenuItem>
                                    </LinkContainer>
                                    <LinkContainer
                                        to={`${location.pathname}/statistics-recipients/${reminder.id}`}
                                    >
                                        <MenuItem>
                                            {locale('reminders.listOfRecipients')}
                                            <Label 
                                                bsStyle="warning"
                                                style={{marginLeft: '4px'}}
                                            >
                                                BETA
                                            </Label>
                                        </MenuItem>
                                    </LinkContainer>
                                    {isCustomType(reminder) && (
                                        <>
                                            <MenuItem divider />
                                            <MenuItem
                                                onClick={() =>
                                                    handleConfirmRemove(
                                                        reminder
                                                    )
                                                }
                                            >
                                                {locale("reminders.remove")}
                                            </MenuItem>
                                        </>
                                    )}
                                </DropdownButton>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    );
};

export default RemindersTable;
